import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register chart.js components
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

interface PointsBarChartProps {
    listOfPointsScored: number[]
};

const PointsBarChartComponent = (props: PointsBarChartProps) => {

    const labels = [10, 9, 8, 7, 6, 5, 4, 3, 2, 1];

    const countOccurrences = () => {
        const counts: Map<number, number> = new Map(labels.map(label => [label, 0]));

        props.listOfPointsScored.forEach((num) => {
            counts.set(num, (counts.get(num) || 0) + 1);
        });

        return Array.from(counts.values())
    };



    // Define the data for the chart
    const data = {
        labels: labels,
        datasets: [
            {
                data: countOccurrences().map(value => value == 0 ? '-' : value),
                backgroundColor: 'rgba(75, 192, 192, 1.0)', // Color of bars
                borderWidth: 0,
            },
        ],
    };

    // Configuration options for the chart
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: false,
            },
            tooltip: {
                enabled: false,
            },
            datalabels: {
                anchor: 'end' as const, // Positioning above the bar
                align: 'end' as const,
                formatter: (value: number) => value.toString(), // Converts number to string
            },
        },
        scales: {
            x: {
                grid: {
                    display: false, // Hide the grid lines for the X-axis
                },
            },
            y: {
                beginAtZero: true, // Start the Y-axis at 0
                max: Math.max(...countOccurrences()) + 1.7,
                display: false,
            },
        },
    };

    return (
        <Bar data={data} options={options} />
    );
};

export default PointsBarChartComponent;